import axios from 'axios'
export default {
  name: 'Actualizar',
  data () {
    return {
      avisos: [], datosperfil: ''
    }
  },
  mounted() {
    if (this.$store.getters.pedirdatos === true){
      this.alertapedirdatos()
    }
  },
  methods: {
  alertapedirdatos () {
    this.datosperfil = swal({
      title: 'Actualiza tu Perfil',
      html:
        '<label for="placa">Mail:</label><input placeholder="mail@gmail.com" id="swal-input1" class="swal2-input" type="email">' +
        '<label for="placa">Dirección:</label><input placeholder="Calle + Nro" id="swal-input2" class="swal2-input">',
      focusConfirm: false,
      confirmButtonText: 'Actualizar',
      preConfirm: (valor) => {
        if(document.getElementById('swal-input1').value != '' && document.getElementById('swal-input2').value != ''){
          return [
            document.getElementById('swal-input1').value,
            document.getElementById('swal-input2').value
          ] 
        } else {
          return false 
        }
        
      }
    }).then((result) => {
      if(result.value){
        axios.post(this.$apibase+'gen/actualizarregistro', {
          "mail": result.value[0], "direccion": result.value[1], "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
        })
        .then( response => this.pasoactregistro(response),  response => this.erroractregistro(response) )
        .catch( response => this.erroractregistro(response))
      }
    })
   },
   pasoactregistro (response) {
    if (response.data.estado === 1){
      this.$store.dispatch('SET_CREDENCIALES', response.data.credenciales)
      if (response.data.credenciales) {
        
      }
    } else {
      this.erroractregistro(response)
    }
   },
   erroractregistro (response) {
   }
  },
  computed: {
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/actualizarregistro.js